<script setup lang="ts">
import { defineProps, RenderFunction } from 'vue'
import { useField } from 'vee-validate'
import { ExclamationCircleIcon } from '@heroicons/vue/outline'
import { twMerge } from 'tailwind-merge'
import { QuestionMarkCircleIcon, InformationCircleIcon } from '@heroicons/vue/solid'

const props = defineProps<{
    name: string
    label?: string
    labelMuted?: string
    labelFontBold?: boolean
    icon?: RenderFunction | null
    required?: boolean
    required2?: boolean
    errorIconClass?: string
    hint?: string
    info?: boolean
    infoAction?: () => void
    standalone?: boolean
}>()

const { errorMessage } = useField(props.name, {}, { standalone: props.standalone ? props.standalone : false })
</script>

<template>
    <div>
        <label
            v-if="props.label"
            :for="props.name"
            class="mb-1 block text-sm text-gray-700"
            :class="{
                'font-medium': !labelFontBold,
                'font-bold': labelFontBold,
                'required': required,
                'required-2': required2,
            }">
            {{ props.label }}

            <span v-if="props.labelMuted" class="ml-1 mr-1 text-gray-400">
                {{ props.labelMuted }}
            </span>
            <QuestionMarkCircleIcon
                v-if="props.hint"
                v-tooltip="props.hint"
                class="-mt-1 inline-block h-6 w-6 text-gray-500"
                aria-hidden="true" />
            <InformationCircleIcon
                v-if="props.info"
                v-tooltip="props.hint"
                class="-mt-1 inline-block h-6 w-6 cursor-pointer text-gray-500"
                aria-hidden="true"
                @click="props.infoAction" />
        </label>

        <div class="relative">
            <div v-if="icon" class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                <Component :is="icon" class="h-5 w-5 text-gray-400" aria-hidden="true" />
            </div>
            <slot></slot>
            <div :class="twMerge('absolute inset-y-0 right-0 flex items-center pr-3', props.errorIconClass)">
                <ExclamationCircleIcon
                    v-if="errorMessage"
                    class="pointer-events-none h-5 w-5 text-red-500"
                    aria-hidden="true" />
                <div>
                    <slot name="add-on"></slot>
                </div>
            </div>
        </div>

        <!--        <ErrorMessage :name="props.name" />-->
        <p v-if="errorMessage" :id="props.name + '-error'" class="mt-2 text-sm text-red-600">{{ errorMessage }}</p>
    </div>
</template>
